import React, { useState } from 'react';
import loadable from '@loadable/component';
import { motion, AnimatePresence } from 'framer-motion';

import CCRoomFilterPng01 from '../../../assets/images/products/room-filter/CC/cc-filter-room-01.png';
import CCRoomFilterWebp01 from '../../../assets/images/products/room-filter/CC/cc-filter-room-01.png?as=webp';
import CCRoomFilterPng02 from '../../../assets/images/products/room-filter/CC/cc-filter-room-02.png';
import CCRoomFilterWebp02 from '../../../assets/images/products/room-filter/CC/cc-filter-room-02.png?as=webp';
import CCRoomFilterPng03 from '../../../assets/images/products/room-filter/CC/cc-filter-room-03.png';
import CCRoomFilterWebp03 from '../../../assets/images/products/room-filter/CC/cc-filter-room-03.png?as=webp';

const ImageLoader = loadable(() => import('../common/ImageLoader'));

const listContents = [{
  title: 'Pet dander',
  description: () => (<p>While your pet’s lazing about the house, they’re shedding dander—tiny flecks of skin—all over the place. Dander often causes allergic reactions in humans, and it can linger for a long, long time on furniture and carpet.</p>),
  image: {
    baseUrl: CCRoomFilterPng01,
    webpUrl: CCRoomFilterWebp01,
    alt: 'Pet dander room',
  },
},
{
  title: 'Smelly odors',
  description: () => (<p>We love our pets, but they sure can raise a stink. Especially cats, who relieve themselves indoors. Cat smell comes primarily from the ammonia generated from decomposing urine in the litter box. 🙀 </p>),
  image: {
    baseUrl: CCRoomFilterPng02,
    webpUrl: CCRoomFilterWebp02,
    alt: 'Smelly odors room',
  },
},
{
  title: 'Pet hair',
  description: () => (<p>Contrary to popular belief, pet hair itself isn’t an allergen. But it can carry allergenic substances like pet dander, urine, and saliva, as well as dust and pollen. Oh, Fido.</p>),
  image: {
    baseUrl: CCRoomFilterPng03,
    webpUrl: CCRoomFilterWebp03,
    alt: 'Pet hair room',
  },
}];

const ProductFilter = () => {
  const [ currentIndex, setCurrentIndex ] = useState(0);
  return (
    <div className='product-filter' style={{ '--primary-color': '#F42C52', '--secondary-color': '#FFF2F5' }}>
      <div className='container container--md'>
        <div className='product-filter__header'>
          <h2 className='product-filter__heading'>
            Clear the air of dander,
            <br />
            allergens, fur and more.
          </h2>
          <h3 className='product-filter__subtitle'>Pets aren’t exactly a breath of fresh air.</h3>
          <div className='product-filter__description'>
            <p>
              Designed for pet parents, this award-winning air purifier with a H13 HEPA  + heavy-duty carbon filter removes pet dander and odors to keep your place free of
              {' '}
              <br />
              animal funk and allergens.
            </p>
          </div>
        </div>
        <div className='product-filter__grid'>
          <div className='product-filter__content'>
            <ul className='product-filter__list'>
              {listContents.map((item, idx) => (
                <li className={`product-filter__item ${currentIndex === idx ? 'product-filter__item--current' : ''}`} key={item.title} onClick={() => setCurrentIndex(idx)}>
                  <div className='product-filter__item-header'>
                    <h3 className='product-filter__title'>{item.title}</h3>
                    <button type='button' className='product-filter__toggle'>
                      {' '}
                      <span className='screen-reader-text'>accordion toggle</span>
                      <svg width='16' height='9' viewBox='0 0 16 9' fill='none' xmlns='http://www.w3.org/2000/svg'>
                        <path d='M14 1.42212L8 7.02212L2 1.42212' stroke='black' strokeWidth='2.4' strokeLinecap='round' strokeLinejoin='round' />
                      </svg>
                    </button>
                  </div>
                  <AnimatePresence>
                    <motion.div
                      className='product-filter__item-body'
                      initial={{ height: 0 }}
                      animate={{ height: currentIndex === idx ? 'auto' : 0 }}
                      transition={{ duration: 0.3 }}
                      style={{ overflow: 'hidden' }}
                    >
                      <div className='product-filter__item-description'>{item.description()}</div>
                    </motion.div>
                  </AnimatePresence>
                </li>
              ))}
            </ul>
          </div>
          <div className='product-filter__media'>
            <ul className='product-filter__media-list'>
              {listContents.map((item, idx) => (
                <li key={item.title} className={`product-filter__media-item ${currentIndex === idx ? 'product-filter__media-item--current' : ''}`}>
                  <ImageLoader
                    className='product-filter__image img-relative'
                    placeholderAspectRatio={630 / 471}
                    image={item.image.baseUrl}
                    webp={item.image.webpUrl}
                    alt={item.image.alt}
                  />
                </li>

              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductFilter;
